import { render } from "./PattyThreadList.vue?vue&type=template&id=5ede20b5&scoped=true"
import script from "./PattyThreadList.vue?vue&type=script&lang=js"
export * from "./PattyThreadList.vue?vue&type=script&lang=js"

import "./PattyThreadList.vue?vue&type=style&index=0&id=5ede20b5&scoped=true&lang=css"

import exportComponent from "../../../../../irap-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ede20b5"]])

export default __exports__